import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import GifPreview from 'shared/components/gif-preview'
import { grid3 } from 'shared/css/grid.css'
import GifProps from 'shared/prop-types/gif'
import { getUrl } from 'shared/util/gif-extract'
import css from './carousel-item.css'

const GRADIENT_PAGE_COUNT = 3
const grid3Width = parseInt(grid3, 10)

export const getOpacity = (index, max) => {
    const cutoff = max * GRADIENT_PAGE_COUNT * 2
    let opacity = index % cutoff

    if (opacity > 8) {
        opacity = cutoff - 1 - opacity
    }

    return opacity
}

export default class ChannelCarouselItem extends PureComponent {
    static propTypes = {
        gif: GifProps,
        gridId: PropTypes.string.isRequired,
        preloadIndex: PropTypes.number.isRequired,
        autoPlay: PropTypes.bool.isRequired,
        itemIndex: PropTypes.shape({
            index: PropTypes.number,
            max: PropTypes.number,
        }),
        backgroundColor: PropTypes.string.isRequired,
    }
    constructor(props) {
        super(props)
        const {
            itemIndex: { index, max },
        } = props
        this.opacity = getOpacity(index, max)
    }
    render() {
        const {
            gif,
            gif: { channelIsPrivate, user, tags },
            autoPlay,
            preloadIndex,
            gridId,
            backgroundColor,
        } = this.props
        const height = grid3Width * (9 / 16)
        const animated = getUrl(gif, 'fixed_height')
        const still = getUrl(gif, 'fixed_height_still')
        const isSticker = gif.is_sticker
        const backgroundImage = isSticker ? `url("../../static/img/backgrounds/bg-tile-dark.png")` : null
        return (
            <div data-opacity={this.opacity} className={css.itemWrapper} style={{ backgroundColor }}>
                <div className={gif.label ? css.labelItem : css.item} style={{ backgroundImage }}>
                    <GifPreview
                        {...{ still, animated, gridId, autoPlay, isSticker, height }}
                        isInPriorityRange={true}
                        isInPreloadRange={false}
                        shouldUseLinkFallback={true}
                        index={preloadIndex}
                        isHidden={false}
                        url={gif.url}
                        handleTap={() => {}}
                        width={grid3Width}
                        beforeAfterProps={{ gif }}
                        user={user}
                        tags={tags}
                        isSticker={isSticker}
                    />
                    {gif.label && (
                        <a
                            data-opacity={this.opacity}
                            className={css.itemLabel}
                            style={{ backgroundColor }}
                            href={gif.url}
                        >
                            <span className={css.itemLabelText}>{gif.label}</span>
                        </a>
                    )}
                </div>
                {channelIsPrivate && (
                    <a href={gif.path || gif.url} className={css.privateOverlay}>
                        <i className={css.privateIcon} />
                    </a>
                )}
            </div>
        )
    }
}
